module.exports = __webpack_public_path__ + "img/belarus.066bac39.svg";